import { createContext, useContext } from "react";

export const MistContext = createContext(() => {});
export const useMist = () => useContext(MistContext);
